import { render, staticRenderFns } from "./AnalysisBusinessRisk.vue?vue&type=template&id=59aabc2b&scoped=true&"
import script from "./AnalysisBusinessRisk.vue?vue&type=script&lang=js&"
export * from "./AnalysisBusinessRisk.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisBusinessRisk.vue?vue&type=style&index=0&id=59aabc2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aabc2b",
  null
  
)

export default component.exports